import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Programmes from './pages/Programmes';
import ProgrammeDetail from './pages/ProgrammeDetail';
import ProjectPage from './pages/ProjectPage';
import Reports from './pages/Reports';
import Expenditure from './pages/Expenditure';
import Budget from './pages/Budget';
import NewProgramme from './pages/NewProgramme';
import NewProject from './pages/NewProject';
import Users from './pages/Users';
import Roles from './pages/Roles';
import './styles/app.css';
const g = (perm, el) => <ProtectedRoute permission={perm}>{el}</ProtectedRoute>;
export default function App() {
  return <AuthProvider><BrowserRouter><Routes>
    <Route path="/login" element={<Login />} />
    <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
      <Route path="/" element={g('dashboard.view', <Dashboard />)} />
      <Route path="/programmes" element={g('programme.view', <Programmes />)} />
      <Route path="/programmes/new" element={g('programme.create', <NewProgramme />)} />
      <Route path="/programmes/:programmeId/projects/new" element={g('project.create', <NewProject />)} />
      <Route path="/programmes/:id" element={g('programme.view', <ProgrammeDetail />)} />
      <Route path="/projects/:id" element={g('project.view', <ProjectPage />)} />
      <Route path="/budget" element={g('expenditure.view', <Budget />)} />
      <Route path="/projects/:id/expenditure" element={g('expenditure.view', <Expenditure />)} />
      <Route path="/reports" element={g('report.view', <Reports />)} />
      <Route path="/reports/:key" element={g('report.view', <Reports />)} />
      <Route path="/admin/users" element={g('user.view', <Users />)} />
      <Route path="/admin/roles" element={g('role.manage', <Roles />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes></BrowserRouter></AuthProvider>;
}
